/* eslint-disable react/no-multi-comp */
import React from 'react';
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@material-ui/core';
import { Field, FieldAttributes, FieldProps } from 'formik';

interface CheckboxProps {
    label?: React.ReactNode;
    disabled?: boolean;
    description?: string;
}

const CheckboxFormFieldComponent: React.SFC<FieldProps & CheckboxProps> = ({
    field,
    meta,
    label,
    disabled,
    description
}) => {
    const isError = meta.touched && !!meta.error;
    return (
        <FormControl error={isError} disabled={disabled} fullWidth>
            <FormControlLabel
                control={
                    <Checkbox
                        color="primary"
                        name={field.name}
                        checked={field.value}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                    />
                }
                label={label}
            />
            {(isError || description) && (
                <FormHelperText error={isError}>{isError ? meta.error : description}</FormHelperText>
            )}
        </FormControl>
    );
};

export const CheckboxFormField: React.SFC<FieldAttributes<CheckboxProps>> = ({
    label,
    description,
    disabled,
    ...props
}) => (
    <Field {...props}>
        {(childProps: FieldProps) => (
            <CheckboxFormFieldComponent
                label={label}
                disabled={disabled}
                description={description}
                {...childProps}
            />
        )}
    </Field>
);
